// Utilidad para manejar la actualización de socios de forma consistente
import { API_ENDPOINTS } from '../config';

export const handleSocioUpdate = async ({
  form,
  socio,
  codigoPais,
  fotoAnterior,
  nuevaFoto,
  setMensaje,
  setError,
  setLoading,
  setSocio,
  setForm,
  setFotoPreview,
  setFotoAnterior,
  setFotoKey,
  socioId,
  validar
}) => {
  setMensaje('');
  setError('');
  
  const errorValidacion = validar();
  if (errorValidacion) {
    setError(errorValidacion);
    return;
  }
  
  setLoading(true);
  
  try {
    // Solo enviar los campos que cambiaron
    const camposCambiados = {};
    Object.keys(form).forEach(key => {
      // Comparar valores considerando tipos booleanos
      let formVal = form[key];
      let socioVal = socio[key];
      
      // Normalizar valores booleanos para comparación
      if (key === 'novedadesMail') {
        formVal = formVal === true || formVal === 'true' || formVal === 1;
        socioVal = socioVal === true || socioVal === 'true' || socioVal === 1;
      }
      
      // Normalizar campo administrador para comparación
      if (key === 'administrador') {
        const formBool = formVal === 'Sí' || formVal === true;
        const socioBool = socioVal === true || socioVal === 'Sí';
        if (formBool !== socioBool) {
          camposCambiados[key] = formBool;
        }
      } else if (formVal !== socioVal) {
        if (key === 'telefono' && form[key]) {
          camposCambiados[key] = codigoPais + ' ' + form[key];
        } else if (key === 'novedadesMail') {
          camposCambiados[key] = form[key] === true || form[key] === 'true' || form[key] === 1;
        } else {
          camposCambiados[key] = form[key];
        }
      }
    });

    // Si hay una foto anterior y es diferente a la actual, agregar la información
    if (fotoAnterior && socio.foto !== fotoAnterior) {
      camposCambiados.fotoAnterior = fotoAnterior;
    }

    // Si hay una nueva foto, considerar que hay cambios (aunque no haya otros campos)
    const hayNuevaFoto = nuevaFoto && nuevaFoto !== null;

    if (Object.keys(camposCambiados).length === 0 && !hayNuevaFoto) {
      setMensaje('No hay cambios para guardar.');
      setLoading(false);
      return;
    }

    const token = localStorage.getItem('token');
    
    let body;
    let headers = {
      'Authorization': 'Bearer ' + token
    };
    
    // Si hay una nueva foto, usar FormData
    if (hayNuevaFoto) {
      body = new FormData();
      Object.keys(camposCambiados).forEach(key => {
        body.append(key, camposCambiados[key]);
      });
      body.append('foto', nuevaFoto);
    } else {
      // Si no hay foto, usar JSON
      headers['Content-Type'] = 'application/json';
      body = JSON.stringify(camposCambiados);
    }
    
    const res = await fetch(`${API_ENDPOINTS.SOCIOS}/${socioId}`, {
      method: 'PUT',
      headers,
      body
    });
    
    if (res.ok) {
      setError(''); // Limpiar errores previos
      setMensaje('Datos actualizados correctamente');
      const data = await res.json();
      if (data.socio) {
        const { construirUrlFoto } = require('./photoUrlHelper');
        const updated = { ...data.socio };
        setSocio(updated);
        // setForm puede recibir el socio directamente o una función transformadora
        if (setForm && typeof setForm === 'function') {
          setForm(updated);
        }
        setFotoPreview(data.socio.foto ? construirUrlFoto(data.socio.foto) : '');
        setFotoAnterior(null);
        setFotoKey(Date.now());
      }
    } else {
      setMensaje(''); // Limpiar mensajes exitosos previos
      const data = await res.json();
      setError(data.message || 'Error al actualizar');
    }
  } catch (err) {
    setMensaje(''); // Limpiar mensajes exitosos previos
    setError('Error de red');
  }
  
  setLoading(false);
};
